'use strict';

const { h } = require('phy');

function CouponsDFPAd({ outerClass, innerClass, innerId }) {
  return h(
    `.${outerClass}`,
    h(`#${innerId}.${innerClass}`, {
      'data-bhw': innerId,
      'data-bh-viewport': 'respect',
    })
  );
}

module.exports = CouponsDFPAd;
